import reducer, {
  initialState,
  /* eslint-disable-next-line import/no-named-as-default */
} from '../../../theme/store/reducers/themes.reducers';

// Types
import type {
  $ActionEnvelope,
  $ReducerActions,
} from '../..';

export type $State = typeof initialState;

export type $Reducer = (
  arg0: $State,
  arg1: $ActionEnvelope<$ReducerActions<$State>>,
) => $State;

export {
  initialState,
};

export default reducer;
